import React from 'react';
import PropTypes from 'prop-types';
import { FINANCIALS_STATUSES } from '../../../constants/constants';
import GraphDonut from '../../Common/GraphDonut/GraphDonut';
import * as types from '../../../constants/actionTypes';
import Notification from '../../Common/Notification';

class LocationDetailsFinancials extends React.Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            financialsSummary: {
                budgetTotal: 0,
                actualTotal: 0,
                underBudgetTaskCount: 0,
                overBudgetTaskCount: 0,
                completedTasksDifference: 0
            }
        }
    }

    componentDidMount = async () => {
        await this.loadFinancialsSummary();
    }

    componentDidUpdate(prevProps) {
        // reload the details when the user changes locations
        // they could be searching for a location so make sure there is a value
        if (this.props.locationKey && this.props.locationKey !== prevProps.locationKey) {
            this.loadFinancialsSummary();
        }
    }

    loadFinancialsSummary = async () => {
        try{
            const response = await this.props.locationDashboardActions.loadFinancialsSummary(this.props.locationKey);
            if (response.type === types.LOAD_FINANCIALS_SUMMARY_SUCCESS) {
                this.setState({
                    financialsSummary: {
                        ...this.state.financialsSummary,
                        ...response.payload
                    }
                });
            } else if (response.type === types.LOAD_FINANCIALS_SUMMARY_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    financialsGraph = (actualNum, budgetNum) => {
        return [
            {
                id: FINANCIALS_STATUSES.Actual.title,
                label: FINANCIALS_STATUSES.Actual.title,
                value: actualNum,
                color: FINANCIALS_STATUSES.Actual.color
            },
            {
                id: FINANCIALS_STATUSES.RemainingBudget.title,
                label: FINANCIALS_STATUSES.RemainingBudget.title,
                value: budgetNum-actualNum,
                color: FINANCIALS_STATUSES.RemainingBudget.color
            }
        ]
    };

    calcPercentage = (actualNum, budgetNum) => {
        return budgetNum != 0 ? Math.round( actualNum/budgetNum * 100)+"%" : "0%";
    }

    render() {
        return(
            <div className="card my-2 financials-card">
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="mb-3">
                                    <label className="form-control-label">Budget</label>
                                    <div className="label-value">{this.state.financialsSummary.budgetTotal}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3">
                                    <label className="form-control-label">Actual Spend To Date</label>
                                    <div className="label-value">{this.state.financialsSummary.actualTotal}
                                        <span>({this.calcPercentage(this.state.financialsSummary.actualTotal, this.state.financialsSummary.budgetTotal)})</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <GraphDonut data={this.financialsGraph(
                                this.state.financialsSummary.actualTotal, 
                                this.state.financialsSummary.budgetTotal
                                )} />
                        </div>
                        <div className="col right-col">
                            <div className="row">
                                <div className="mb-3">
                                    <label className="form-control-label">{this.state.financialsSummary.underBudgetTaskCount} Tasks Under Budget</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3">
                                    <label className="form-control-label">{this.state.financialsSummary.overBudgetTaskCount} Tasks Exceeded Budget</label>
                                </div>
                            </div>

                            <div className="row">
                                <div className="mb-3">
                                    <label className="form-control-label">{this.state.financialsSummary.completedTasksDifference >= 0 ? "Budget Savings" : "Over Budget"}</label>
                                    <div className="label-value">{this.state.financialsSummary.completedTasksDifference}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LocationDetailsFinancials.propTypes = {
    locationKey: PropTypes.string.isRequired,
    locationDashboardActions: PropTypes.object.isRequired,
};

export default LocationDetailsFinancials;